import AWS from "aws-sdk";
// import dotenv from "dotenv";

const S3_BUCKET = "asfdocumentstorage";
const REGION = "us-west-2";
const accessKey=process.env.REACT_APP_s3accessKeyId;
const secret=process.env.REACT_APP_s3secretAccessKey;

AWS.config.update({
  accessKeyId: accessKey,
  secretAccessKey: secret,
});

const s3 = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

export async function uploadFileToSDK(file, document_id, application_id) {
  const param = {
    Bucket: S3_BUCKET,
    Key: `${application_id}/${document_id}.pdf`,
    Body: file,
  };
  try {
    const uploadResult = await s3.upload(param).promise();
    return uploadResult;
  } catch (error) {
    console.log("Upload error: ", error);
  }
}

export async function removeFileFromSDK(file, document_id, application_id) {
  const param = {
    Bucket: S3_BUCKET,
    Key: `${application_id}/${document_id}.pdf`,
  };

  try {
    const deleteResult = await s3.deleteObject(param).promise();
    return deleteResult;
  } catch (error) {
    console.log("Upload error: ", error);
  }
}
